import * as React from 'react';
import DiMarkdown from './DiMarkdown';

function Insight({ insight } :any) {
  const [copyNotification, setCopyNotification] = React.useState<boolean>(false);

  const copyToClipboard = (content: string) => {
    navigator.clipboard.writeText(content);
    setCopyNotification(true);
    // Clear the notification after 2 seconds
    setTimeout(() => {
      setCopyNotification(false);
    }, 2000);
  };

  return (
    <div>
      <div className="page-header">
        <h3 className="page-title"> </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item"><a href="/my_projects">My Projects</a></li>
            <li className="breadcrumb-item"><a href={`/projects/${insight.project.id}`}>{insight.project.title}</a></li>
            <li className="breadcrumb-item active" aria-current="page">{insight.title}</li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title"></h4>
              <p className="card-description">
              </p>
              <h5 className="mt-4 mb-3"></h5>
              <div className="row">
                <div className="col-lg-9 col-md-12">
                  <div key={insight.id} className="insight-card">
                    <div className="insight-header">
                      <h4 className="insight-title">{insight.title}</h4>
                      <div className="insight-meta">
                        <span>AI: {insight.ai_assistant}</span>
                        <span>Created: {insight.created_at}</span>
                      </div>
                    </div>
                    <div className="insight-content">
                      <p>
                        <DiMarkdown>{insight.content}</DiMarkdown>
                      </p>
                      <p><strong>Task:</strong> {insight.task}</p>
                    </div>
                    <div className="insight-actions">
                      <button
                        onClick={() => {
                          // Copy insight content to clipboard
                          copyToClipboard(insight.content);
                        }}
                        className="action-btn"
                        title="Copy Insight"
                      >
                        Copy
                      </button>
                      <button
                        onClick={() => {
                          // Download insight content as a text file
                          const element = document.createElement("a");
                          const file = new Blob([insight.content], { type: 'text/plain' });
                          element.href = URL.createObjectURL(file);
                          element.download = `${insight.title?.slice(0, 20) || 'insight'}_insight.txt`;
                          document.body.appendChild(element);
                          element.click();
                          document.body.removeChild(element);
                        }}
                        className="action-btn"
                        title="Download Insight"
                      >
                        Download
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Copy Notification */}
              {copyNotification && (
                <div className="copy-notification">
                  <span>Copied to clipboard!</span>
                </div>
              )}

              <style>{`
                .insight-card {
                  border: 1px solid #e0e0e0;
                  border-radius: 0.5rem;
                  padding: 1rem;
                  margin-bottom: 1rem;
                  transition: background-color 0.3s ease;
                  background-color: #f8f9fa;
                }
                .insight-header {
                  display: flex;
                  flex-direction: column;
                  margin-bottom: 0.5rem;
                }
                .insight-title {
                  margin-bottom: 0.5rem;
                }
                .insight-meta {
                  font-size: 0.875rem;
                  color: #6c757d;
                }
                .insight-meta span {
                  margin-left: 1rem;
                }
                .insight-content {
                  margin-top: 0.5rem;
                }
                .insight-actions {
                  display: flex;
                  justify-content: flex-end;
                  margin-top: 1rem;
                }
                .action-btn {
                  background-color: #e0e0e0;
                  color: #333333;
                  margin-left: 0.5rem;
                  padding: 0.25rem 0.5rem;
                  border: none;
                  border-radius: 0.25rem;
                  cursor: pointer;
                  font-weight: 500;
                }
                .action-btn:hover {
                  background-color: #d0d0d0;
                }
                .copy-notification {
                  position: fixed;
                  bottom: 20px;
                  right: 20px;
                  background-color: #4caf50;
                  color: white;
                  padding: 10px 20px;
                  border-radius: 4px;
                  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
                  z-index: 1000;
                  animation: fadeInOut 2s ease-in-out;
                }
                @keyframes fadeInOut {
                  0% { opacity: 0; transform: translateY(20px); }
                  15% { opacity: 1; transform: translateY(0); }
                  85% { opacity: 1; transform: translateY(0); }
                  100% { opacity: 0; transform: translateY(-20px); }
                }
                .row {
                  display: flex;
                  flex-wrap: wrap;
                }
                .col-lg-9 {
                  width: 75%;
                }
                @media (max-width: 992px) {
                  .col-lg-9 {
                    width: 100%;
                  }
                }
                @media (max-width: 768px) {
                  .insight-header {
                    flex-direction: column;
                    align-items: flex-start;
                  }
                  .insight-meta span {
                    display: block;
                    margin-left: 0;
                  }
                }
              `}</style>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Insight;
